import http from './http'

const transportadoraService = {
  getAll: page => http.get(`/transportadoras?page=${page}`).then(result => result.data),
  getAllZero: () => http.get(`/transportadorasall`).then(result => result.data),
  getAllAtivos: page => http.get(`/clientes/ativos/?page=${page}`),
  getById: id => http.get(`/transportadoras/${id}`).then(result => result.data.data),
  getByIdAtivo: id => http.get(`/clientes/ativos/${id}`).then(result => result.data.data),
  getByNome: (str, page) => http.get(`/transportadorasgetnome/${str}?page=${page}`).then(result => result.data),
  getByNomeAtivo: str => http.get(`/clientes/ativos/${str}`).then(result => result.data),
  delete: id => http.delete(`/transportadorasdelete/${id}`).then(result => result.data.data),
  getTransportadorasHabilitadas: () => http.get(`/transportadorashabilitadas`).then(result => result.data),
  savePost: data => http({
    method: 'post',
    url: `/transportadoras`,
    data
  }).then(result => result.data.data),
  savePut: data => http({
    method: 'put',
    url: `/transportadoras/${data.id}`,
    data
  }).then(result => result.data.data)
}
export default transportadoraService
